import type { FaireProductEntity } from "../../entity_types/product";

export const p_bxy4h8nf96: FaireProductEntity = {
  token: "p_bxy4h8nf96",
  type: "product",
  name: "Cozy Mode Master Hanging Decor",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/617fab67dc8556ba5be10b47c5bca6a5c81e7cea20aad00ab698a81eab30419f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c6444d957f3f36551bc6e2f1b8b280508022c133376b041e7285ca2051dc3e64.jpeg",
    "https://cdn.faire.com/fastly/db4ad4a778a670600847e36096bfdbfc81a553344dc8a57b7e0794f2d036a42a.jpeg",
    "https://cdn.faire.com/fastly/a4e400ee1af7f8a46a1c5847459804da097c39f587cec9e9faa616765dbe323f.jpeg"
  ],
  priceDollars: 5,
  description: "A ready to hang metal tin sign from our Slow Living Collection displaying a hand illustrated design of an award that reads \"Cozy Mode Master\" perfect for those who enjoy cozy home life. Cozy living sign features metal with embossed details for added dimension. Our Cozy Mode Master metal wall décor is easy to hang against wall using the included mounting hardware and pre-drilled holes. A cozy living home accent that easily adds personality to any space.",
  tags: [],
  msrpDollars: 9.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:41.575Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
